export class TokenExtensions {
  public static getParsedJwt(token: string) {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (error) {
      return undefined;
    }
  }

  public static getTokenFromLocalStorage(): any {
    for (const prop in localStorage) {
      if (prop.includes('idtoken')) {
        return JSON.parse(localStorage.getItem(prop)!);
      }
    }

    return '';
  }
}
